import type { StepKey } from '@components/Checkout/Checkout.types';

export const STANDARD_CHECKOUT_STEP_KEYS_AUTHENTICATED: StepKey[] = [
  'order',
  'payment',
  'thankyou'
];

export const STANDARD_CHECKOUT_STEP_KEYS_ANONYMOUS: StepKey[] = [
  'order',
  'account',
  'payment',
  'thankyou'
];

export function getStandardCheckoutStepKeys(isLogged: boolean): StepKey[] {
  return isLogged
    ? STANDARD_CHECKOUT_STEP_KEYS_AUTHENTICATED
    : STANDARD_CHECKOUT_STEP_KEYS_ANONYMOUS;
}
